export default __webpack_public_path__ + "static/media/health-care-fsa-guide.c24a628c.svg";